import gql from 'graphql-tag';

const archiveOutputQuery = gql`
  mutation ArchiveOutput($outputId: String!) {
    archiveOutput(outputId: $outputId) {
      archivedAt
      outputId
    }
  }
`;

const archiveOutput = {
  mutation: archiveOutputQuery,
  module: 'video',
  buildVariables: (outputId: string) => ({ outputId })
} as const;

export default archiveOutput;
